import apiClient from './apiClient'

/**
 * Responsible for managing oauth login flow between 3rd party sites
 *
 * 1) Opens popup to provider site based on server's app token
 * 2) user accepts, enters username password on provider site
 * 3) provider site redirects back to the dashboard with a token in the url
 * 4) popup posts message back to parent window with the token
 * 5) parent window creates the credential asynchronously, and calls back to child window to close once the credential is added
 *
 */
export const PERMISSION_CHATTER = 'CHATTER'
export const PERMISSION_REVIEW_RESPONSES = 'REVIEW_RESPONSES'


export function requestUserAccessFromProvider(provider, permissions = [PERMISSION_CHATTER], accountId) {
  let featureString = (window.top !== window ? `location=1,status=1,width=${Math.min(600, window.outerWidth)},height=${Math.min(600, window.outerHeight)}` : undefined)

  let childWindow = window.open('/loading.html', '_blank', featureString);

  return apiClient.get(`/credentials/remoteAuthUrl/${provider}?permissions=${permissions.join(',')}${accountId ? '&accountId=' + accountId : ''}`, {
    // include cookies (used to juggle whitelabels while retaining a single primary redirect host for provider whitelisting (e.g. live.chatmeter.com))
    withCredentials: true
  })
    .then(x => x.data)
    .then(txt => {
      return new Promise((resolve, reject) => {
        console.info('redirecting to provider url', txt)
        childWindow.location.href = txt;

        let messageListener = function (event) {
          let payload = event.data
          try {
            payload = JSON.parse(event.data)
          } catch (e) {}

          if (payload && payload.type && payload.type === "OAUTH_CONFIRM")
            extractTokensFromUrl(provider, payload.url).then((json) => {
              event.source.postMessage(JSON.stringify({type: "OAUTH_COMPLETE", success: true}), "*")
              resolve(json)
              setTimeout(function () {
                childWindow.close();
              }, 2000)

              window.removeEventListener("message", messageListener, false)
            })
        }

        window.addEventListener("message", messageListener, false)
      })
    });

}

/**
 * called when provider completes oauth, and is redirects to our (or whitelabelled) site with oauth token in the url
 * @param provider
 * @returns {Promise<any>}
 */
export function onCallbackReceived(provider) {

  return new Promise(function (resolve, reject) {
    window.opener.postMessage(JSON.stringify({type: "OAUTH_CONFIRM", url: window.location.href}), "*")
    window.addEventListener("message", function (event) {
      let parsed = JSON.parse(event.data)
      if (parsed.type === "OAUTH_COMPLETE") {
        if (parsed.success) {
          resolve()
        } else {
          reject(parsed.error)
        }
      }
    }, false)
  })
}

/**
 * hits server to insert the completed credentials into the database
 * @param provider - string
 * @param token - string
 * @param secret - string
 * @returns {Promise<Response>}
 */
function insertCredential(provider, token, secret) {
  return apiClient.post(`/credentials/createAuthToken/${provider}`, {
    oAuthToken: token,
    oAuthSecret: secret
  })
    .then((response) => {
      return response.data
    })
}

function extractTokensFromUrl(provider, url) {

  let qsMatches = url.match(/\?(.+)#/), qs = null;
  if (qsMatches.length > 1) {
    let splitList = qsMatches[1].split('&').map(tuple => tuple.split('=').map(decodeURIComponent))
    qs = _.reduce(splitList, (context, value) => {
      context[value[0]] = value[1]
      return context;
    }, {});
  }

  let token = qs.code || qs.oauth_token
  let secret = qs.oauth_verifier || ''

  return insertCredential(provider, token, secret)
}
